export default __webpack_public_path__ + "static/stadium_banner-213b0a0df59bcdc800f2a723fccb482a.png";